
// import { motion } from "framer-motion";
// import React, { useState } from "react";
// import BarcodeScannerComponent from "react-qr-barcode-scanner";
// import tick from "../../images/tick.gif";
// import { useAppSetting } from "../../context/appSettingContext";


// const BarcodeScanner = ({ onScan, getData }) => {
//   const [isCameraOpen, setIsCameraOpen] = useState(false);
//   const [scannedData, setScannedData] = useState(null);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [isOptionsOpen, setIsOptionsOpen] = useState(false);
//   const [isInputOpen, setIsInputOpen] = useState(false);
//   const [cardNumber, setCardNumber] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [cardError, setCardError] = useState("");
//   const [mobileError, setMobileError] = useState("");

//   const { appSettings } = useAppSetting();
//   const Mobile_length = appSettings?.Mobile_length || 10;
//   const Enable_Mobile_Verificaiton = appSettings?.Enable_Mobile_Verificaiton;
//   const buttonHeight = "50px";

//   // CAMERA TOGGLE
//   const toggleCamera = () => {
//     if (!isCameraOpen) {
//       setIsLoading(true);
//       setIsCameraOpen(true);
//       setTimeout(() => setIsLoading(false), 1000);
//     } else {
//       setIsCameraOpen(false);
//       setError("");
//       setScannedData(null);
//       setShowSuccess(false);
//       if (onScan) onScan("");
//     }
//   };

//   // SCAN SUCCESS
//   const handleSuccessfulScan = (result) => {
//     navigator.vibrate?.(25);
//     setScannedData(result.text);
//     setShowSuccess(true);

//     setTimeout(() => {
//       setShowSuccess(false);
//       setIsCameraOpen(false);
//       //   if (onScan) {
//       //     //   onScan(result.text);


//       //   }
//       setCardNumber(result.text)
//       setIsInputOpen(true);
//     }, 2000);
//   };

//   // MOBILE INPUT CHANGE
//   const handleMobileChange = (e) => {
//     const value = e.target.value.replace(/\D/g, "");
//     setMobileNumber(value);

//     if (value.length > 0 && value.length < Mobile_length) {
//       setMobileError(`Mobile number must be ${Mobile_length} digits`);
//     } else {
//       setMobileError("");
//     }
//   };

//   // VERIFY BUTTON CLICK
//   const handleVerify = () => {
//     let isValid = true;

//     // CARD VALIDATION
//     if (!cardNumber.trim()) {
//       setCardError("Card number is required");
//       isValid = false;
//     } else {
//       setCardError("");
//     }

//     // MOBILE VALIDATION (ONLY IF ENABLED)
//     if (Enable_Mobile_Verificaiton) {
//       if (!mobileNumber.trim()) {
//         setMobileError("Mobile number is required");
//         isValid = false;
//       } else if (mobileNumber.length !== Mobile_length) {
//         setMobileError(`Mobile number must be ${Mobile_length} digits`);
//         isValid = false;
//       } else {
//         setMobileError("");
//       }
//     }

//     if (!isValid) return;

//     const data = Enable_Mobile_Verificaiton
//       ? { mob: mobileNumber, card: cardNumber }
//       : { card: cardNumber };

//     setScannedData(cardNumber);
//     getData(data);
//     setCardNumber("");
//     setMobileNumber("");
//   };


//   const handleReset = () => {
//     setCardNumber("");
//     setMobileNumber("");
//     setCardError("");
//     setMobileError("");
//   };

//   return (
//     <div style={{ textAlign: "center" }}>
//       <div
//         style={{
//           width: "100%",
//           borderRadius: "8px",
//           backgroundColor: "rgba(247, 246, 251, 1)",
//         }}
//       >
//         {/* OPTION BUTTON */}
//         {!isCameraOpen && !isOptionsOpen && !isInputOpen && (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//             <button
//               onClick={() => setIsOptionsOpen(true)}
//               className="btn btn-link text-black w-100"
//             >
//               Are you already a customer?
//             </button>
//           </motion.div>
//         )}

//         {/* OPTIONS */}
//         {isOptionsOpen && (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//             <div className="d-flex flex-column flex-md-row p-3 gap-2 bg-white rounded shadow-sm">
//               <button
//                 className="btn bg-wafaa-purple text-white w-100"
//                 onClick={() => {
//                   setIsOptionsOpen(false);
//                   toggleCamera();
//                 }}
//               >
//                 Scan Your Card
//               </button>

//               <button
//                 className="btn btn-secondary w-100"
//                 onClick={() => {
//                   setIsOptionsOpen(false);
//                   setIsInputOpen(true);
//                 }}
//               >
//                 Enter Card Number
//               </button>
//             </div>
//           </motion.div>
//         )}

//         {/* MANUAL INPUT */}
//         {isInputOpen && (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//             <div
//               style={{
//                 backgroundColor: "#fff",
//                 padding: "20px",
//                 borderRadius: "8px",
//                 position: "relative",
//               }}
//             >
//               {/* CLOSE BUTTON */}
//               <button
//                 className="fa-solid fa-xmark"
//                 style={{
//                   position: "absolute",
//                   top: "10px",
//                   right: "10px",
//                   background: "none",
//                   border: "none",
//                   color: "red",
//                   fontSize: "18px",
//                   cursor: "pointer",
//                 }}
//                 onClick={() => {
//                   setIsInputOpen(false);
//                   setCardNumber("");
//                   setMobileNumber("");
//                   setCardError("");
//                   setMobileError("");
//                 }}
//               />

//               {/* CARD INPUT */}
//               {/* <input
//                 type="text"
//                 value={cardNumber}
//                 onChange={(e) => {
//                   setCardNumber(e.target.value);
//                   if (e.target.value.trim()) setCardError("");
//                 }}
//                 placeholder="Enter your card number"
//                 style={{
//                   width: "100%",
//                   padding: "8px",
//                   border: cardError ? "1px solid red" : "1px solid #ddd",
//                   borderRadius: "5px",
//                   marginTop: "10px",
//                 }}
//               /> */}
//               <input
//                 type="text" // keep text to control input fully
//                 value={cardNumber}
//                 onChange={(e) => {
//                   // allow only digits
//                   const value = e.target.value.replace(/\D/g, "");
//                   setCardNumber(value);
//                   if (value.trim()) setCardError("");
//                 }}
//                 placeholder="Enter your card number"
//                 style={{
//                   width: "100%",
//                   padding: "8px",
//                   border: cardError ? "1px solid red" : "1px solid #ddd",
//                   borderRadius: "5px",
//                   marginTop: "10px",
//                 }}
//               />
//               {cardError && (
//                 <div
//                   style={{
//                     color: "red",
//                     fontSize: "12px",
//                     marginTop: "4px",
//                     textAlign: "left",
//                   }}
//                 >
//                   {cardError}
//                 </div>
//               )}

//               {/* MOBILE INPUT ONLY IF ENABLED */}
//               {Enable_Mobile_Verificaiton && (
//                 <div className="mt-3">
//                   <input
//                     type="tel"
//                     value={mobileNumber}
//                     onChange={handleMobileChange}
//                     placeholder="Enter Mobile Number"
//                     style={{
//                       width: "100%",
//                       padding: "8px",
//                       border: mobileError
//                         ? "1px solid red"
//                         : "1px solid #ddd",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   {mobileError && (
//                     <div
//                       style={{
//                         color: "red",
//                         fontSize: "12px",
//                         marginTop: "4px",
//                         textAlign: "left",
//                       }}
//                     >
//                       {mobileError}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* VERIFY BUTTON */}
//               <div className="d-flex flex-column flex-md-row gap-2 mt-4"

//               >
//                 <button
//                   onClick={handleReset}
//                   style={{
//                     flex: "1 1 30%",          // 50% width on medium+ screens
//                     padding: "12px",
//                      height: "45px",
//                     color: "red",              // text color red
//                     backgroundColor: "transparent", // transparent background
//                     border: "2px solid red",   // red border
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Reset
//                 </button>
//                 <button
//                   onClick={handleVerify}
//                   className="bg-wafaa-purple"
                
//                   disabled={!cardNumber || !mobileNumber} // disables if either is empty
//                   style={{
//                     flex: "1 1 70%", // 50% width on medium+ screens
//                     padding: "12px",
//                     color: "#fff",
//                       height: "45px",
//                     border: "none",
//                     borderRadius: "5px",
//                     cursor: !cardNumber || !mobileNumber || mobileNumber.length !== Mobile_length ? "not-allowed" : "pointer",
//                     opacity: !cardNumber || !mobileNumber || mobileNumber.length !== Mobile_length ? 0.6 : 1,
//                   }}
//                 >
//                   Verify
//                 </button>


//               </div>

//             </div>
//           </motion.div>
//         )}

//         {/* CAMERA */}
//         {isCameraOpen && (
//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: 20 }}
//             transition={{ duration: 0.4 }}
//             className="d-flex justify-content-center"
//             style={{
//               position: "relative",
//               backgroundColor: "white",
//               padding: "5px 10px",
//               borderRadius: "4px",
//               boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
//               textAlign: "center",
//               marginBottom: "10px",
//             }}
//           >
//             <div style={{ position: "relative", background: "#fff" }}>
//               <BarcodeScannerComponent
//                 // formats={["qr_code", "ean_13", "code_128"]}
//                 width={"100%"}
//                 height={"100%"}
//                 onUpdate={(err, result) => {
//                   if (err) {
//                     setError("Error scanning barcode");
//                     console.error(err);
//                     return;
//                   }
//                   if (result) {
//                     handleSuccessfulScan(result);
//                   }
//                 }}
//               />
//               {!isLoading && (
//                 <div
//                   style={{
//                     display: showSuccess ? "none" : "block",
//                     position: "absolute",
//                     top: "50%",
//                     left: "50%",
//                     width: "100%",
//                     height: "100%", // Adjust height to cover most of the container
//                     background: "transparent",
//                     pointerEvents: "none",
//                     zIndex: 2,
//                     transform: "translate(-50%, -50%)", // Centers the grid
//                     overflow: "hidden",
//                   }}
//                 >
//                   {/* Grid Lines Animation using Borders */}
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       height: "100%",
//                       display: "grid",
//                       gridTemplateColumns: "repeat(auto-fill, minmax(5px, 1fr))", // Creates vertical lines with 5px width
//                       gridTemplateRows: "repeat(auto-fill, minmax(5px, 1fr))", // Creates horizontal lines with 5px height
//                       zIndex: 2,
//                       animation: "scan-animation 2s linear infinite",
//                     }}
//                   >
//                     {/* Create grid lines using divs */}
//                     {[...Array(1000)].map((_, index) => (
//                       <div
//                         key={index}
//                         style={{
//                           borderTop: "2px solid rgba(0, 255, 0, 0.3)", // Horizontal lines
//                           borderLeft: "2px solid rgba(0, 255, 0, 0.3)", // Vertical lines
//                           opacity: "0.5",
//                           animation: "fade-opacity 2s ease-in-out infinite", // Gradual opacity animation
//                         }}
//                       />
//                     ))}
//                   </div>
//                 </div>
//               )}






//               {showSuccess && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "100%",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     background: "rgba(255,255,255,0.8)",
//                   }}
//                 >
//                   <img src={tick} alt="success" width="80%" />
//                 </div>
//               )}

//               <div
//                 onClick={toggleCamera}
//                 className="fa-solid fa-xmark"
//                 style={{
//                   position: "absolute",
//                   top: "10px",
//                   right: "10px",
//                   color: "red",
//                   fontSize: "22px",
//                   cursor: "pointer",
//                 }}
//               />
//             </div>
//           </motion.div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BarcodeScanner;

import { motion } from "framer-motion";
import React, { useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import tick from "../../images/tick.gif";
import { useAppSetting } from "../../context/appSettingContext";

const BarcodeScanner = ({ onScan, getData }) => {
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [scannedData, setScannedData] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [isInputOpen, setIsInputOpen] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [cardError, setCardError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const { appSettings } = useAppSetting();

  const Mobile_length = appSettings?.Mobile_length;
  const Enable_Mobile_Verificaiton = appSettings?.Enable_Mobile_Verificaiton;

  const isLengthValidationEnabled =
    Mobile_length && Number(Mobile_length) > 0;

  // CAMERA TOGGLE
  const toggleCamera = () => {
    if (!isCameraOpen) {
      setIsLoading(true);
      setIsCameraOpen(true);
      setTimeout(() => setIsLoading(false), 1000);
    } else {
      setIsCameraOpen(false);
      setError("");
      setScannedData(null);
      setShowSuccess(false);
      if (onScan) onScan("");
    }
  };

  // SCAN SUCCESS
  const handleSuccessfulScan = (result) => {
    navigator.vibrate?.(25);
    setScannedData(result.text);
    setShowSuccess(true);

    setTimeout(() => {
      setShowSuccess(false);
      setIsCameraOpen(false);
      setCardNumber(result.text);
      setIsInputOpen(true);
    }, 2000);
  };

  // MOBILE INPUT CHANGE
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setMobileNumber(value);

    if (
      isLengthValidationEnabled &&
      value.length > 0 &&
      value.length < Mobile_length
    ) {
      setMobileError(`Mobile number must be ${Mobile_length} digits`);
    } else {
      setMobileError("");
    }
  };

  // VERIFY BUTTON CLICK
  const handleVerify = () => {
    let isValid = true;

    // CARD VALIDATION
    if (!cardNumber.trim()) {
      setCardError("Card number is required");
      isValid = false;
    } else {
      setCardError("");
    }

    // MOBILE VALIDATION
    if (Enable_Mobile_Verificaiton) {
      if (!mobileNumber.trim()) {
        setMobileError("Mobile number is required");
        isValid = false;
      } else if (
        isLengthValidationEnabled &&
        mobileNumber.length !== Mobile_length
      ) {
        setMobileError(`Mobile number must be ${Mobile_length} digits`);
        isValid = false;
      } else {
        setMobileError("");
      }
    }

    if (!isValid) return;

    const data = Enable_Mobile_Verificaiton
      ? { mob: mobileNumber, card: cardNumber }
      : { card: cardNumber };

    setScannedData(cardNumber);
    getData(data);
    setCardNumber("");
    setMobileNumber("");
  };

  const handleReset = () => {
    setCardNumber("");
    setMobileNumber("");
    setCardError("");
    setMobileError("");
  };

  const isVerifyDisabled =
    !cardNumber ||
    (Enable_Mobile_Verificaiton &&
      (!mobileNumber ||
        (isLengthValidationEnabled &&
          mobileNumber.length !== Mobile_length)));

  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          width: "100%",
          borderRadius: "8px",
          backgroundColor: "rgba(247, 246, 251, 1)",
        }}
      >
        {/* OPTION BUTTON */}
        {!isCameraOpen && !isOptionsOpen && !isInputOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <button
              onClick={() => setIsOptionsOpen(true)}
              className="btn btn-link text-black w-100"
            >
              Are you already a customer?
            </button>
          </motion.div>
        )}

        {/* OPTIONS */}
        {isOptionsOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div className="d-flex flex-column flex-md-row p-3 gap-2 bg-white rounded shadow-sm">
              <button
                className="btn bg-wafaa-purple text-white w-100"
                onClick={() => {
                  setIsOptionsOpen(false);
                  toggleCamera();
                }}
              >
                Scan Your Card
              </button>

              <button
                className="btn btn-secondary w-100"
                onClick={() => {
                  setIsOptionsOpen(false);
                  setIsInputOpen(true);
                }}
              >
                Enter Card Number
              </button>
            </div>
          </motion.div>
        )}

        {/* MANUAL INPUT */}
        {isInputOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "8px",
                position: "relative",
              }}
            >
              {/* CLOSE */}
              <button
                className="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "none",
                  border: "none",
                  color: "red",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIsInputOpen(false);
                  handleReset();
                }}
              />

              {/* CARD INPUT */}
              <input
                type="text"
                value={cardNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setCardNumber(value);
                  if (value.trim()) setCardError("");
                }}
                placeholder="Enter your card number"
                style={{
                  width: "100%",
                  padding: "8px",
                  border: cardError ? "1px solid red" : "1px solid #ddd",
                  borderRadius: "5px",
                  marginTop: "10px",
                }}
              />
              {cardError && (
                <div style={{ color: "red", fontSize: "12px", marginTop: "4px", textAlign: "left" }}>
                  {cardError}
                </div>
              )}

              {/* MOBILE INPUT */}
              {Enable_Mobile_Verificaiton && (
                <div className="mt-3">
                  <input
                    type="tel"
                    value={mobileNumber}
                    onChange={handleMobileChange}
                    placeholder="Enter Mobile Number"
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: mobileError ? "1px solid red" : "1px solid #ddd",
                      borderRadius: "5px",
                    }}
                  />
                  {mobileError && (
                    <div style={{ color: "red", fontSize: "12px", marginTop: "4px", textAlign: "left" }}>
                      {mobileError}
                    </div>
                  )}
                </div>
              )}

              {/* BUTTONS */}
              <div className="d-flex flex-column flex-md-row gap-2 mt-4">
                <button
                  onClick={handleReset}
                  style={{
                    flex: "1 1 30%",
                    padding: "12px",
                    height: "45px",
                    color: "red",
                    backgroundColor: "transparent",
                    border: "2px solid red",
                    borderRadius: "5px",
                  }}
                >
                  Reset
                </button>

                <button
                  onClick={handleVerify}
                  disabled={isVerifyDisabled}
                  className="bg-wafaa-purple"
                  style={{
                    flex: "1 1 70%",
                    padding: "12px",
                    height: "45px",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: isVerifyDisabled ? "not-allowed" : "pointer",
                    opacity: isVerifyDisabled ? 0.6 : 1,
                  }}
                >
                  Verify
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default BarcodeScanner;